// extracted by mini-css-extract-plugin
export default {"SearchControlPanel":"SearchControlPanel_SearchControlPanel__pgL7d"};